var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-flex',{staticClass:"icon-label",class:{'no_pointer': _vm.no_pointer},attrs:{"align-center":"","no_pointer":_vm.no_pointer}},[_c('svg',{directives:[{name:"svg",rawName:"v-svg"}],staticClass:"icon",attrs:{"symbol":_vm.icon_name,"size":_vm.size,"role":"presentation"}}),_c('span',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }